import { takeEvery, put  } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import { IAction, ISuccessResponse } from '@Root/types'
import Logger from '@Utils/Logger'

import {
  StatisticsActionTypes,
  IGetCreditUsagePayload,
  IGetProjectCreationPayload,
  IGetCreditUsageSuccessResponseBody,
  IGetProjectCreationSuccessResponseBody,
} from './types'

import {
  getCreditUsageSuccess,
  getCreditUsageFailure,
  getProjectCreationSuccess,
  getProjectCreationFailure,
} from './actions'

import * as API from './api'

const call: any = Eff.call

function* getCreditUsageSaga(action: IAction<IGetCreditUsagePayload>) {
  try {
    const response: ISuccessResponse<IGetCreditUsageSuccessResponseBody> = yield call(API.getCreditUsage, action.payload)

    yield put(getCreditUsageSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Credit usage statistics could not be loaded')
    yield put(getCreditUsageFailure())
  }
}

function* getProjectCreationSaga(action: IAction<IGetProjectCreationPayload>) {
  try {
    const response: ISuccessResponse<IGetProjectCreationSuccessResponseBody> = yield call(API.getProjectCreation, action.payload)

    yield put(getProjectCreationSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Project creation statistics could not be loaded')
    yield put(getProjectCreationFailure())
  }
}

function* statisticsSagas() {
  yield takeEvery(StatisticsActionTypes.GET_CREDIT_USAGE, getCreditUsageSaga)
  yield takeEvery(StatisticsActionTypes.GET_PROJECT_CREATION, getProjectCreationSaga)
}

export default statisticsSagas
